const getOrCreateLegendList = ({ chart, id, customContainerStyles }) => {
  const legendContainer = document.getElementById(id)
  let listContainer = legendContainer.querySelector('ul')

  if (!listContainer) {
    const listContainerStyles = {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      margin: 0,
      padding: 0,
      ...customContainerStyles
    }

    listContainer = document.createElement('ul')
    Object.keys(listContainerStyles).forEach(key => {
      listContainer.style[key] = listContainerStyles[key]
    })

    legendContainer.appendChild(listContainer)
  }

  return listContainer
}

export const getHtmlLegendPlugin = (customContainerStyles = {}, customBoxSpansTemplate = {}) => {
  return {
    id: 'htmlLegend',
    afterUpdate(chart, args, options) {
      const ul = getOrCreateLegendList({ chart, id: options.containerID, customContainerStyles })

      // Remove old legend items
      while (ul.firstChild) {
        ul.firstChild.remove()
      }

      // Reuse the built-in legendItems generator
      const items = chart.options.plugins.legend.labels.generateLabels(chart)

      items.forEach((item, index) => {
        const li = document.createElement('li')
        li.style.alignItems = 'center'
        li.style.cursor = 'pointer'
        li.style.display = 'flex'
        li.style.flexDirection = 'row'
        li.style.marginLeft = '10px'

        li.onclick = () => {
          const { type } = chart.config
          if (type === 'pie' || type === 'doughnut') {
            // Pie and doughnut charts only have a single dataset and visibility is per item
            chart.toggleDataVisibility(item.index)
          } else {
            chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex))
          }
          chart.update()
        }

        // Color box
        const boxSpan = document.createElement('span')
        boxSpan.style.background = item.fillStyle
        boxSpan.style.borderColor = item.strokeStyle
        boxSpan.style.borderWidth = item.lineWidth + 'px'
        boxSpan.style.display = 'inline-block'
        boxSpan.style.flexShrink = 0
        boxSpan.style.height = '16px'
        boxSpan.style.marginRight = '10px'
        boxSpan.style.width = '16px'
        boxSpan.style.borderRadius = '3px'

        // Text
        const textContainer = document.createElement('p')
        textContainer.style.color = '#000'
        textContainer.style.margin = 0
        textContainer.style.padding = 0
        textContainer.style.textDecoration = item.hidden ? 'line-through' : ''

        const text = document.createTextNode(item.text)
        textContainer.appendChild(text)

        li.appendChild(customBoxSpansTemplate[index] || boxSpan)
        li.appendChild(textContainer)
        ul.appendChild(li)
      })
    }
  }
}
